// Singleton map storing leadId → { chatId, channelType } for SLB-active chats.
// Populated by the bulk auto-respond fetch, consumed by Stage.handleLeadClick.
// Using a module-level singleton because Pipe.hook.tsx has Vite HMR issues
// that prevent useState changes from being picked up.

type tSlbChatInfo = { chatId: string; channelType: string };

const slbChatMap = new Map<string, tSlbChatInfo>();

export function setSlbChatMapping(leadId: string, info: tSlbChatInfo): void {
  slbChatMap.set(leadId, info);
}

export function clearSlbChatMap(): void {
  slbChatMap.clear();
}

export function getSlbChatForLead(leadId: string): tSlbChatInfo | undefined {
  return slbChatMap.get(leadId);
}
